import styled, { keyframes } from 'styled-components';

const DURATION = '2.063s';
const POT_EASE = 'cubic-bezier(1, -0.009, 0, 0.993)';
const SEED_EASE = 'cubic-bezier(1, -0.008, 0, 0.986)';
const GHOST_OPACITY = 0.95192;

const potMotion = keyframes`
  0% {
    transform: translate(0, 0) rotate(5deg);
  }

  100% {
    transform: translate(-0.421px, 2.9px) rotate(0deg);
  }
`;

const ghostLeftMotion = keyframes`
  0% {
    opacity: ${GHOST_OPACITY};
    transform: translateX(0);
  }

  63.16%,
  100% {
    opacity: 0;
    transform: translateX(60.713px);
  }
`;

const ghostRightMotion = keyframes`
  0% {
    opacity: ${GHOST_OPACITY};
    transform: translateX(0);
  }

  63.16%,
  100% {
    opacity: 0;
    transform: translateX(-59.287px);
  }
`;

const seedOneMotion = keyframes`
  0% {
    transform: translateY(-13px);
    animation-timing-function: linear;
  }

  13.91% {
    transform: translateY(-13px);
    animation-timing-function: ${SEED_EASE};
  }

  89.89%,
  100% {
    transform: translateY(0);
  }
`;

const seedTwoMotion = keyframes`
  0% {
    transform: translateY(-17.5px);
    animation-timing-function: linear;
  }

  6.38% {
    transform: translateY(-17.5px);
    animation-timing-function: ${SEED_EASE};
  }

  82.37%,
  100% {
    transform: translateY(0);
  }
`;

const seedThreeMotion = keyframes`
  0% {
    transform: translateY(-17.5px);
    animation-timing-function: ${SEED_EASE};
  }

  75.99%,
  100% {
    transform: translateY(0);
  }
`;

const dotOneMotion = keyframes`
  0%,
  6.38% {
    transform: translateY(0);
  }

  92.47%,
  100% {
    transform: translateY(7.219px);
  }
`;

const dotTwoMotion = keyframes`
  0%,
  10% {
    transform: translateY(0.204px);
  }

  100% {
    transform: translateY(8.344px);
  }
`;

const dotThreeMotion = keyframes`
  0%,
  13.91% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-13.531px);
  }
`;

const Illustration = styled.svg`
  display: block;
  width: 183px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;

  @media (prefers-reduced-motion: reduce) {
    g {
      animation: none;
    }
  }
`;

const Layer = styled.g`
  transform-box: fill-box;
  transform-origin: center;
`;

const Pot = styled(Layer)`
  animation: ${potMotion} ${DURATION} ${POT_EASE} infinite alternate;
`;

const GhostLeft = styled(Layer)`
  animation: ${ghostLeftMotion} ${DURATION} ${POT_EASE} infinite alternate;
`;

const GhostRight = styled(Layer)`
  animation: ${ghostRightMotion} ${DURATION} ${POT_EASE} infinite alternate;
`;

const SeedOne = styled(Layer)`
  animation: ${seedOneMotion} ${DURATION} linear infinite alternate;
`;

const SeedTwo = styled(Layer)`
  animation: ${seedTwoMotion} ${DURATION} linear infinite alternate;
`;

const SeedThree = styled(Layer)`
  animation: ${seedThreeMotion} ${DURATION} linear infinite alternate;
`;

const DotOne = styled(Layer)`
  animation: ${dotOneMotion} ${DURATION} linear infinite alternate;
`;

const DotTwo = styled(Layer)`
  animation: ${dotTwoMotion} ${DURATION} linear infinite alternate;
`;

const DotThree = styled(Layer)`
  animation: ${dotThreeMotion} ${DURATION} linear infinite alternate;
`;

export {
  DotOne,
  DotThree,
  DotTwo,
  GhostLeft,
  GhostRight,
  Illustration,
  Pot,
  SeedOne,
  SeedThree,
  SeedTwo,
};
